import { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';

interface RoleBasedRouteProps {
    adminComponent?: ReactNode;
    proprietaireComponent?: ReactNode;
    locataireComponent?: ReactNode;
    fallback?: ReactNode;
}

/**
 * Composant qui affiche différents composants selon le rôle de l'utilisateur
 * Sans changer l'URL
 */
export default function RoleBasedRoute({ 
    adminComponent, 
    proprietaireComponent, 
    locataireComponent,
    fallback 
}: RoleBasedRouteProps) {
    const { user } = useAuth();

    if (!user) {
        return <>{fallback || <div>Chargement...</div>}</>;
    }

    switch (user.role) {
        case 'ADMIN':
            return <>{adminComponent || fallback}</>;
        case 'PROPRIETAIRE':
            return <>{proprietaireComponent || fallback}</>;
        case 'LOCATAIRE':
            return <>{locataireComponent || fallback}</>;
        default:
            return <>{fallback || <div>Rôle non reconnu</div>}</>;
    }
}
